<template>
  <div
      ref="scrollBox2"
      id="PicPanel"
      class="pic-wrap" v-if="detail.preview_water_pic || detail.preview_pic">

    <div class="pic-img-box"
         :class="[
             {'pic-img-box-ai':detail.is_transform_ai == 1 },
             {'bgGray':detail.is_transform_ai == 1 && detail.transform_show.base_color == 1 },
             {'bgBlack':detail.is_transform_ai == 1 && detail.transform_show.base_color == 2 },
             {'elementPicIsScale80': elementPicIsScale80 },

             {'vertical':detail.is_transform_ai == 1 && detail.transform_show.show_type &&  detail.transform_show.show_type == 2 },
             {'horizontal':detail.is_transform_ai == 1 && detail.transform_show.show_type &&  detail.transform_show.show_type == 1 },
             {'pic-img-box-ai-80':detail.is_transform_ai == 1 && detail.transform_show.transform_type !=1 &&  detail.transform_show.show_type &&  detail.transform_show.show_type == 2 },
         ]">

      <PicImgBox class="PicImgBox" :pic-item="detail" pic-size=""
      ></PicImgBox>

      <PicTagCollectNew class="_PicTagCollectNew1" :pic-item-info="detail"
                        v-bind="$attrs"
                        v-on="$listeners"

      />

      <TupianMask v-if="spider"/>


      <div class="mask" v-show="!isLogin"></div>

      <no-ssr>
        <LoginFloater class="LoginFloater"/>
        <slot name="picContent"></slot>
      </no-ssr>


    </div>

    <!-- 正版图标 -->

    <div class="legal-copy-wrap">
      <NavigationTo :path="MEMBER_LICENSE_VIP">
      <span slot="content" class="legal-copy free"
            v-if="detail.layer == 1"
      >免费下载</span>
        <span slot="content" class="legal-copy person"
              v-if="detail.layer == 2"
        >个人会员</span>
        <span slot="content" class="legal-copy person"
              v-if="detail.layer == 3"
        >个人会员</span>
        <span slot="content" class="legal-copy company"
              v-if="detail.layer == 4"
        >企业商用</span>
      </NavigationTo>
    </div>

    <!--    <NavigationTo :path="MEMBER_LICENSE_VIP">
          <span slot="content" class="legal-copy legal-copy-active">商用授权
            <i class="iconfont icon-a-arrowright"/>
          </span>
        </NavigationTo>-->

    <div
        :class="[ isFixed == true ? 'no' :'on' , { 'active':showImgPanel }]"
        class="pic-introduce-panel inner_center"
        ref="picIntroducePanel"
    >
      <h1 v-if="detail.package !== 1"
          class="panel-title overflow-more">{{ detail.title }}
      </h1>
      <!-- 普通图片下载按钮 -->
      <div
          class="panel-btn-group">

        <!--  AI -->
        <div
            v-if="detail.is_ai == 1"
            class=" download-btn download-btn2 _pointer download-btn-plain_ai"
            :class=" 'download-btn'+ vipType"
            @click="download(detail,1);tag('充值:详情页立即下载按钮:图片')">

          <no-ssr>
            <template v-if="!isLogin">
              免费下载
            </template>
            <template v-else>

              <div v-if="(personVipState != 1 && businessVipState != 1 && companyVipState != 1)">
                <span v-if=" vipType >= detail.layer">{{ '免费下载' }}</span>
                <span v-else>{{ '下载' + detail.file_type }}</span>
              </div>
              <div v-show="personVipState == 1 || businessVipState == 1 || companyVipState == 1">
                {{ '下载' + detail.file_type }}
              </div>

            </template>
          </no-ssr>

          <!--          <span v-show="free_remain > 0 && vipIsPerson != 1 && vipIsBusiness != 1 && companyVipState != 1">
                      (今日剩余<span class="free-remain-txt">{{ free_remain }}</span>次)
                    </span>-->
        </div>

        <!-- 非AI -->

        <template v-if="detail.is_ai == 0">
          <div
              class="download-btn _pointer"
              :class=" 'download-btn'+ vipType"
              @click="download(detail,2);tag('充值:详情页立即下载按钮:图片')">
            {{ '下载源文件' }}
          </div>
          <div
              class=" download-btn-plain download-btn2 _pointer"
              :class=" 'download-btn-layer'+ vipType"
              @click="download(detail,1);tag('充值:详情页立即下载按钮:图片')">

            <no-ssr>
              <!--              <template v-if="!isLogin">
                              免费下载
                            </template>
                            <template v-else>-->

              <div v-if="(personVipState != 1 && businessVipState != 1 && companyVipState != 1)">
                <!--                  <span v-if=" vipType >= detail.layer">{{ '免费下载' }}</span>-->
                <span>{{ '下载' + detail.file_type }}</span>
              </div>
              <div v-show="personVipState == 1 || businessVipState == 1 || companyVipState == 1">
                {{ '下载' + detail.file_type }}
              </div>

              <!--              </template>-->
            </no-ssr>

            <!--          <span v-show="free_remain > 0 && vipIsPerson != 1 && vipIsBusiness != 1 && companyVipState != 1">
                        (今日剩余<span class="free-remain-txt">{{ free_remain }}</span>次)
                      </span>-->
          </div>
        </template>


        <!--        <div
                  :class="[ isCollect == 1? 'like-btn-active': 'like-btn-default' ]"
                  class="like-btn _pointer "
                  @click="toggleLike()">
                  <i class="iconfont icon-collect4"/>
                </div>-->
        <div
            class="like-btn _pointer "
            @click="buyLeaflet()">
          <!--          <i class="iconfont icon-collect4"/>-->
          单张 <br>
          购买
        </div>
      </div>


      <no-ssr>
        <!--        <InviteReceive class="InviteReceive" :entry="8"/>-->
        <!--        <RemindButton :entry="8"/>-->

        <MandateBar ref="MandateBar"
                    :detail="detail"
                    @MandateBarHover="MandateBarHover"
        >
          <div slot="MandateBarContent">
            <DownloadInterestModal/>
          </div>
        </MandateBar>
        <DetailEquity/>
      </no-ssr>
      <ul class="panel-purpose _hide">
        <li>
          <i class="iconfont icon-gou"/>
          <span class="label">下载范围：</span>
          <!--          <a
                      :href="PAGE_PATH.BASE_URL + PAGE_PATH.INTRODUCE.VIP"
                      target="_blank"
                      v-if="detail.layer != 4"
                      class="btn">个人</a>
                    <a
                      :href="PAGE_PATH.BASE_URL + PAGE_PATH.INTRODUCE.COMPANY_VIP"
                      target="_blank"
                      class="btn btn-company">企业</a>-->

          <!--          <a :href="PAGE_PATH.BASE_URL + PAGE_PATH.PAYMENT.BUSINESS" @click="tag('充值:详情页下载范围:图片:click')" target="_blank" class="legal-copy free"
                       v-if=" 1 >= detail.layer"
                    >免费下载</a>-->


          <a :href="PAGE_PATH.BASE_URL + PAGE_PATH.PAYMENT.COMPANY" @click="tag('充值:详情页下载范围:图片:click')" target="_blank"
             class="legal-copy company"
             v-if="4 >= detail.layer"
          >企业商用</a>
          <a :href="PAGE_PATH.BASE_URL + PAGE_PATH.PAYMENT.BUSINESS" @click="tag('充值:详情页下载范围:图片:click')" target="_blank"
             class="legal-copy business"
             v-if="3 >= detail.layer"
          >个人商用</a>
          <a :href="PAGE_PATH.BASE_URL + PAGE_PATH.PAYMENT.PERSON" @click="tag('充值:详情页下载范围:图片:click')" target="_blank"
             class="legal-copy person"
             v-if="2 >= detail.layer "
          >会员专享</a>
        </li>

        <li>
          <i class="iconfont icon-gou"/>
          <span class="label">授权方式：</span>
          <a
              :href="PAGE_PATH.BASE_URL + PAGE_PATH.INTRODUCE.COMPANY_VIP"
              target="_blank"
              class="value">VRF授权</a>
        </li>
        <li>
          <i class="iconfont icon-gou"/>
          <span class="label">版权归属：</span>
          <a
              :href="PAGE_PATH.BASE_URL + PAGE_PATH.INTRODUCE.COMPANY_VIP"
              target="_blank"
              class="value">潮国创意</a>
        </li>
      </ul>

      <PicInfo v-bind="$attrs"/>

      <!--      <VipUpgradePanel />-->

      <DetailFormatPanel :detail="detail"/>

      <!--  新人优惠券 -->
      <!--      <no-ssr>
              <div
                v-if="isHasUserCoupon && isLogin"
                class="new-user-coupon _user-select"
                @click="navigateTo"
              >
                <i class="icon_coupon"/>
                <div class="txt-coupon">您有一张新人专享券待使用</div>
                <div class="txt-coupon-use">立即使用</div>
              </div>
            </no-ssr>-->
      <no-ssr>
        <PicReportModal :detail="detail"/>
        <!--        <water-wave-ball/>-->

        <!--        <slot name="picPanelContent"></slot>-->
      </no-ssr>

    </div>
  </div>
</template>

<script>
import {MATERIAL_DOWNLOAD, MEMBER_LICENSE_VIP, PAY_BUSINESS} from "@/constant/PATH";
import {tag} from "@/utils/statUtil";
import {toggleMaterialCollect} from "@/api/material";
import {mapState} from "vuex";
import {InviteReceive} from "../../act/invite";
import {fnBindIphone, fnFlowStatistics, fnGuideDownloadCount, fnLogin, fnRouter, fnUser} from "@/fn";
import {DownloadInterceptDialog} from "@/components/material";
import {getCookie} from "@/utils/auth";
import WaterWaveBall from '@/components/tupian/water-wave-ball/water-wave-ball'
import LoginFloater from '@/components/common/login/login-floater/login-floater.vue'
import PicReportModal from './pic-report-modal'
import panelExtend from "@/components/tupian/detail/common/panelExtend";

import RemindButton from '@/components/tupian/detail/remind-button';
import {PAGE_PATH} from '@/constant/PAGE_PATH'
import {HOME} from "@/constant/HOME";
import PicInfo from '@/components/tupian/detail/pic-info'
import MandateBar from '@/components/tupian/detail/mandate-bar'
import DownloadInterestModal from '@/components/_components/pic/detail/DownloadInterestModal'
import PicTagCollectNew from '@/components/pic/pic-tag/pic-tag-collection-new';


/* 引入公共方法和常量 */
import * as fnCommon from '@/fn/_fn';
import * as CON_COMMON from '@/constant/_constant';
import PicImgBox from '@/components/_Privately/Pic/PicImgBox'
import {getMultipleList, leafletDownloadCheck} from "@/api/pay";
import {fnBasic} from "@/fn/_fn";
import {INTRODUCE_MULTIPLE} from "@/constant/_Public/Path";

export default {
  name: "TuPianDetailPicPanel",
  mixins: [panelExtend],
  props: {
    /* 详情 */
    detail: {
      type: Object,
      default: () => {
      }
    },
    /* 是否展示面板-动画效果判断 */
    showImgPanel: {
      type: Boolean,
      default: false
    },
    /* 是否收藏 */
    isCollect: {
      type: Number | String,
      default: 0
    },
    /* 图片包状态判断 */
    picPackageDescState: {
      type: Boolean,
      default: false
    },
    /* 图片包描述 */
    picPackageDesc: {
      type: Object,
      default: () => {
      }
    },
    customAHref: ''
  },
  computed: {
    ...mapState('user', ['isLogin', 'vipIsPerson', 'vipIsBusiness']),
    ...mapState('user',
        [
          'personVipState',
          'personVipInfo',
          'businessVipState',
          'businessVipInfo',
          'companyVipState',
          'companyVipInfo',
          'isHasUserCoupon',
          'isSwitchAccountType',
          'isSwitchCompanyMain',
        ]
    ),
    ...mapState('base', ['isBoot', 'header', 'spider']),
    free_remain() {
      let {
        day_free_limit, today_free_down, free_down_cnt, down_cnt
      } = this.$store.state.user.downloadCount;
      /* 判断总免费次数是否有用完 */
      let free_remain = free_down_cnt - down_cnt > 0 ? (day_free_limit - today_free_down) : 0;
      return free_remain;
    },

    picLink() {
      let {preview_water_pic} = this.detail
      return preview_water_pic.indexOf('.gif') > -1 ? 'https://pic.chaopx.com' + preview_water_pic : 'https://pic.chaopx.com' + preview_water_pic + '!/fw/672/quality/90/unsharp/true/compress/true'

    },
    picPreviewLink() {
      let {preview_pic} = this.detail
      return preview_pic.indexOf('.gif') > -1 ? 'https://pic.chaopx.com' + preview_pic : 'https://pic.chaopx.com' + preview_pic + '!/fw/672/quality/90/unsharp/true/compress/true'

    },

    /* 元素图片是否需要吗缩放80% */
    elementPicIsScale80() {

      const {image_width = 0, image_height = 0} = this.detail;
      if (image_height > 864) {
        return true;
      } else {
        return false;
      }

    }
  },
  components: {
    InviteReceive,
    DownloadInterceptDialog,
    WaterWaveBall,
    LoginFloater,
    PicReportModal,
    RemindButton,
    PicInfo,
    MandateBar,
    DownloadInterestModal,
    PicTagCollectNew,
    PicImgBox

  },
  watch: {
    isSwitchAccountType: {
      handler(n, o) {
        console.log(n)
        if (n == true) {
          console.log('-- isSwitchAccountType 登录检查VIP --')
          setTimeout(() => {
            this.init();
          }, 500)
        }
      }
    },
    isSwitchCompanyMain: {
      handler(n, o) {
        console.log(n)
        if (n == true) {
          // console.log('-- PicButtonGroup isSwitchCompanyMain --')
          setTimeout(() => {
            this.init();
          }, 500)
        }
      }
    },
  },
  data() {
    return {
      MEMBER_LICENSE_VIP,
      isFixed: true,
      PAGE_PATH,
      vipType: 1,
      isOpenTimer: false,
      customLink: ''
    }
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);

    this.init();
    console.log('this.detail.layer' + this.detail.layer)
    this.customLink = fnCommon.fnUser.getUserVipUpgradeLinkByPicLayer(parseInt(this.detail.layer));
    setTimeout(() => {
      this.handleScroll()
    }, 1000)
  },
  destroyed() {
    document.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    init() {
      this.$store.commit('user/SET_SWITCH_ACCOUNT_TYPE', false)
      this.vipType = this.getUserMaxVip();
      console.log(this.getUserMaxVip())
    },

    getUserMaxVip() {
      let personVipState = getCookie('personVipState')
      let businessVipState = getCookie('businessVipState')
      let companyVipState = getCookie('companyVipState')
      if (companyVipState == 1) {
        return 4
      } else if (businessVipState == 1) {
        return 3
      } else if (personVipState == 1) {
        return 2
      } else {
        return 1
      }
    },
    picReport() {

    },
    handleScroll() {
      if (!!this.$refs.scrollBox2) {
        let scrollTop = this.$refs.scrollBox2.getBoundingClientRect().bottom
        let height = this.$refs.scrollBox2.offsetHeight;
        this.isFixed = scrollTop >= this.$refs.picIntroducePanel.offsetHeight;
      }
    },
    download(detail, channel) {
      fnFlowStatistics.pageFlow('detailDown')
      this.$emit('download', detail, channel)
    },

    tag(stat) {
      tag(stat)
    },
    toggleLike() {
      this.$emit('toggleLike');
    },

    navigateTo() {
      fnGuideDownloadCount.trackNewUser(HOME.NEW_USER_COUPON_TYPE.HORIZON, HOME.NEW_USER_COUPON_TYPE.POSITION.CURRENT_PAGE)
      fnRouter.navigationTo(PAGE_PATH.PAYMENT.BUSINESS)
    },

    MandateBarHover() {
      /* 检测是否显示权益框 */
      let userMaxGradeVip = fnCommon.fnUser.getUserMaxGradeVip();
      if (userMaxGradeVip < this.detail.layer) {
        this.isOpenTimer = false;
        this.$refs.DownloadInterestModal.isShow = true;
      }
    },

    buyLeaflet() {
      let path = CON_COMMON.CON_BASIC.PAY_LEAFLET + `/${this.detail.uniq_id}.html`;

      /* 判断用户是否授权该图片 */
      leafletDownloadCheck({pic_id: this.detail.uniq_id}).then(res => {
        const {status, data} = res.data;
        if (status == 200) {
          if (data.isAuth > 0) {
            /* 已授权 */
            this.toLeaflet();
          } else {

            /* 未授权判断用户是否有剩余可授权张数 */
            this.getMultipleList();


          }
        } else {
          this.toLeaflet();
        }
      })
    },

    getMultipleList() {
      getMultipleList().then(res => {
        console.log({res})
        const {status, data} = res.data;
        if (status == 200) {
          /* 如果data为null 或者为空数组 */
          if (data === null || (Array.isArray(data) && data.length === 0)) {
            // data 是 null 或者是一个空数组
            // console.log("data 是 null 或者是一个空数组");
            /* 随机取多张支付或者多张介绍页 */
            /*const randomValue = Math.random();
            if (randomValue < 0.5) {
              this.toLeaflet();
            } else {
              fnBasic.navigationTo(INTRODUCE_MULTIPLE)
            }*/
            this.toLeaflet();

          } else {
            // console.log("data 不是 null 且不是一个空数组");
            /* 判断非空数组，下载次数是否使用完毕 */
            let isHasDownNumber = data.every(item => item.use_num == item.num);
            if (isHasDownNumber){
              fnBasic.navigationTo(INTRODUCE_MULTIPLE)
            }else{
              /*data.sort((a, b) => b.auth_type - a.auth_type);
              this.multipleMealList = data;
              this.showMultipleListModal = true;*/
              this.toLeaflet();
            }
          }
        }
      })
    },


    toLeaflet() {
      let path = CON_COMMON.CON_BASIC.PAY_LEAFLET + `/${this.detail.uniq_id}.html`;
      fnCommon.fnPay.dataTrackByClickLeaflet()
      tag('充值:单张购买按钮:图片:click')
      fnBasic.navigationTo(path)
    }
  },

  filters: {

    iconClassHoverText(val) {
      switch (val) {
        case 'icon_ps':
          return 'Adobe Photoshop';
        case 'icon_3dMax':
          return '3D Max';
        case 'icon_cdr':
          return 'Coreldraw';
        case 'icon_ai':
          return 'Adobe lllustrator';
        case 'icon_c4d':
          return 'Cinema 4D';
        case 'icon_sketch':
          return 'Sketch App';
        case 'icon_blender':
          return 'Blender';
      }
    }
  }
}
</script>

<style lang="scss" scoped>

@import "./styles/pic-report";
@import "components/tupian/detail/common/detail";

.pic-img-box {
  position: relative;

  /deep/ .PicImgBox {
    //transition: all 0s ease 0s !important;
    //pointer-events: none;
    &:hover {
      .pic-img {
        transform: scale(1.00) !important;
      }
    }
  }

  &.pic-img-box-ai {
    @include BgImage(660px, 864px, 'test/3.jpg');
    border-radius: 14px;
  }

  &.bgGray {
    @include BgImage(660px, 864px, 'test/2.jpg');
  }

  &.bgBlack {
    @include BgImage(660px, 864px, 'test/1.jpg');
  }

  /*&.elementPicIsScale80 {
    img {
      width: 80% !important;
    }
  }

  &.vertical {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &.pic-img-box-ai-80 {
    img {
      width: 80%;
    }
  }

  &.horizontal {

    .pic-img {
      padding: 30px 20px 0;
      box-sizing: border-box;
    }

    .pic-img2 {
      margin-top: 70px;
      border-radius: 0 !important;
      padding: 0 !important;
    }
  }*/

}

.PicTagCollectNew {
  top: 16px !important;
}


#PicPanel {
  /deep/ .PicImgBox {
    ._prototype_horizontal_stretch {
      .CustomImage {
        display: flex;
        align-items: center;
        justify-content: center;

        img {
          width: 70% !important;
          height: 85% !important;
        }
      }
    }
  }

}


</style>
